export default "__VITE_ASSET__BlCcMQx6__"